// extracted by mini-css-extract-plugin
export default {"section":"EmptyHouse_section__0BNhQ","content":"EmptyHouse_content__08Qb0"};